import { RadioCard, RadioCardButtonSize } from "@/atoms-react/radio-card/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import { FromURL } from "@/features/flow/types";
import { cn } from "@/features/utils/cn";

type PaymentRadioProps = {
  isActive: boolean;
  onClick: () => void;
  label: string;
  children: React.ReactNode;
  disabled?: boolean;
};

export const PaymentRadio = ({
  isActive,
  onClick,
  label,
  children,
  disabled = false
}: PaymentRadioProps) => (
  <RadioCard
    origin={FromURL.None}
    buttonSize={RadioCardButtonSize.SMALL}
    className={cn(
      "mt-2 min-h-full xs:max-w-64 flex-1 items-start rounded-tl-lg rounded-tr-none rounded-br-lg rounded-bl-none border-[3px] md:ml-2 md:w-1/4",
      !isActive && "border-slate-100"
    )}
    active={isActive}
    onClick={disabled ? () => {} : onClick}
  >
    <Base className={"ml-2 font-bold"}>{label}</Base>
    {children}
  </RadioCard>
);
